import { loadingController } from "@ionic/vue";
export default {
    // Simple loader
    simpleLoader(text: "Salvataggio in corso", timeout: 4000, dismissable: true) {
        loadingController
            .create({
                message: text,
                duration: timeout,
                backdropDismiss: dismissable,
            })
            .then((response) => {
                response.present();
            });
    },
    // Dismiss loader
    dismissLoader() {
        loadingController
            .dismiss()
            .then((response) => {
                console.log("Loader closed!", response);
            })
            .catch((err) => {
                console.log("Error occured : ", err);
            });
    },
    // Auto hide show loader
    autoLoader(text: "Salvataggio in corso", timeout: 4000, dismissable: true) {
        loadingController
            .create({
                message: text,
                duration: timeout,
                backdropDismiss: dismissable,
            })
            .then((response) => {
                response.present();
                response.onDidDismiss().then((response) => {
                    console.log("Loader dismissed", response);
                });
            });
    },
    // Custom style + hide on tap loader
    customLoader(text: "salvataggio in corso", timeout: 4000, dismissable: true) {
        loadingController
            .create({
                message: text,
                duration: timeout,
                cssClass: "loader-css-class",
                backdropDismiss: dismissable,
            })
            .then((res) => {
                res.present();
            });
    },
};
